import styled from "styled-components"
import React from "react"
import { Input } from "client/components"


export const ListTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px 10px;
`
export const ListTitle = styled.div`
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.defaultTextColor};
`
export const ListProgress = styled.div`
    font-weight: 600;
    font-size: 20px;
    font-family: ${(props) => props.theme.openSans};
`


export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const TargetDescription = styled.div`
    font-size: 13px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.keyResultTypeColor};
`
export const DeadlineDescription = styled.div`
    font-size: 12px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.keyResultDeadlineColor};
`

export const KeyResultDeadlineWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
export const KeyResultDeadlineDescription = styled.div`
    font-family: ${(props) => props.theme.openSans};
    font-size: 13px;
    color: ${(props) => props.theme.keyResultDeadlineDescriptionColor};
`

const InputWrapper = styled.div`
    display: flex;
    
    ${Input} {
        flex-grow: 1;
    }
    
    input[type="number"] {
        -moz-appearance: textfield;
        -webkit-appearance: textfield;
        appearance: textfield;
    }
    
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        display: none;
    }
`
const Metric = styled.div`
    padding: 6px 8px;
    margin-bottom: 8px;
    min-width: 30px;
    text-align: center;
    background: ${(props) => props.theme.keyResultMetricBackground};
    color: ${(props) => props.theme.keyResultMetricColor};
`

interface MetricInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    metric: string
    metricAfter: boolean
}
export const MetricInput = ({
    metric,
    metricAfter,
    ...other
}: MetricInputProps) => (
    <InputWrapper>
        {
            metric && !metricAfter
            && <Metric>{metric}</Metric>
        }
        <Input type="number" {...other} />
        {
            metric && metricAfter
            && <Metric>{metric}</Metric>
        }
    </InputWrapper>
)
